import { findIndex } from "lodash";
//import sendxAPI from '../../../xAPI'

const templateState = {
  id: -1,
  type: null,
  isOn: false
};

export function LightReducer(
  state = { light: [] },
  action
) {
  let currentLight;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
    return state;
  }

  if (
    action.type !== "CREATE_LIGHT" &&
    !action.type.includes("@redux")
  ) {
    if (action.payload.hasOwnProperty("id")) {
      if (
        state.protocolSection.scene.apparatus.hasOwnProperty("light")
      ) {
        currentLight =
          state.protocolSection.scene.apparatus.light[
            findIndex(state.protocolSection.scene.apparatus.light, {
              id: action.payload.id,
            })
          ];
      }
    }
  }

  switch (action.type) {
    case "CREATE_LIGHT":
      //Create new obj from template state
      let newObj = { ...templateState, ...action.payload.props };

      if (protocolSection.scene.apparatus.hasOwnProperty("light")) {
        protocolSection.scene.apparatus.light = [
          ...protocolSection.scene.apparatus.light,
          newObj,
        ];
      } else {
        protocolSection.scene.apparatus.light = [newObj];
      }

      return {
        ...state,
        ...{
          protocolSection: protocolSection,
        },
      };
      case "LIGHT_TOGGLE_ON":
        //Create new obj from template state
        // let newObj = { ...templateState, ...action.payload.props };
       
        currentLight = state.protocolSection.scene.apparatus.light[action.payload.id-1];
        currentLight.isOn = !currentLight.isOn;

        return {
          ...state,
          ...{
            protocolSection: protocolSection,
          },
        };
  
    case "UNDO":
      //Payload = {lastState}

      if (action.payload.lastState !== null && protocolSection.scene.apparatus.hasOwnProperty('light')) {
        protocolSection.scene.apparatus.light =
          action.payload.lastState.scene.apparatus.light;

        return {
          ...state,
          ...{
            protocolSection: protocolSection,
          },
        };
      } else {
        return state;
      }

    default:
      return state;
  }
}
